
import React, { Suspense, useState, useEffect } from "react";
import WizardServices from "./WizardServices";

export default function ContactSummary(MainWizard: any) {

   // console.log(MainWizard.data)
    return (<>

        <div className="box ">

            <div className="box-header pm" style={{ paddingBottom: "15px !important" }}>
                <h2>Contact Summary</h2>
            </div>

            <div className="box-content" style={{ height: "610px" }}>

                <div className="ws-12">
                    <div className="ws-12 pm mb">

                        <div className="creatorImg pm pull-left">
                            <div className="box shadowCoverPicture shadow">
                                <div className="coverPicture"> <img className="ws-12" src={MainWizard.data.creatorImage} />  </div>
                                <div className="ws-12 pm">
                                    <label className="control-label ws-12 text-bold text-uppercase">  {MainWizard.data.kontactDisplay}</label>
                                    <label className="control-label ws-12 text-bold text-uppercase ms"> {MainWizard.data.kontactCode}</label>
                                </div>
                            </div>
                        </div>


                    </div>

                    <div className="form-format ws-12 mtl">
                        <label className="w-45">Contact Code :</label>
                        <div className="label-entries ws-6"> {MainWizard.data.kontactCode} </div>
                    </div>

                    <div className="form-format">
                        <label className="w-45">Contact Name :</label>
                        <div className="label-entries ws-6"> {MainWizard.data.kontactDisplay} </div>
                    </div>

                </div>

                <div className="ws-12 centerWindow pl hide">

                <div className="ws-9 pm centerWindow">
                    <label className="icon-btn primary mll" >Upload Image</label>

                    <input type="file" accept="*" id="file-upload" ngf-select="" ng-model="file" ng-accept=".jpg" ng-model-rejected="rejFiles" />
                </div>

                </div>

            </div>

        </div>

    </>)

}